import { uploadFinalDecisionDocumentFile } from "@synthesis/shared-services";

export const REJECT_MODAL_TITLE = "Оформление отказа";

export const REJECT_MODAL_HEADING = "Отказ в выдаче технических условий";

export const REJECT_REASON_LABEL = "Обоснование решения";

export const REJECT_REASON_PLACEHOLDER =
  "Укажите причины отказа: технические ограничения, несоответствие требованиям или отсутствие необходимых данных.";

/** Легаси-метка обычных вложений, которыми раньше помечали документы отказа. PUT attachments остаётся для описаний файлов заявки. */
export const REJECT_DECISION_ATTACHMENT_DESCRIPTION = "FINAL_DECISION_ATTACHMENT";

export const REJECT_SNACK_MESSAGES = {
  pending: "Выполняется оформление отказа...",
  fulfilled: "Отказ оформлен и направлен заявителю",
  rejected: "Не удалось оформить отказ",
} as const;

export const REJECT_SNACK_DESCRIPTIONS = {
  pending: "",
  fulfilled: "Рассмотрение заявки завершено",
  rejected: "Попробуйте еще раз",
} as const;

export const uploadRejectDocuments = async ({
  requestId,
  files,
  userId,
}: {
  requestId: string;
  files: File[];
  userId: string;
}): Promise<string[]> => {
  if (files.length === 0) {
    return [];
  }

  const uploadedFileIds: string[] = [];

  for (const file of files) {
    const fileMeta = await uploadFinalDecisionDocumentFile({ requestId, filename: file.name, userId }, file);

    if (!fileMeta.id) {
      throw new Error("API не вернул идентификатор файла");
    }

    uploadedFileIds.push(fileMeta.id);
  }

  return uploadedFileIds;
};
